import { Reducer } from "redux";

interface State {
    token: string,
    logado: boolean,
    tenantId: string,
    expirado: boolean,
    administrador: boolean,
    tentativasDeLogin: number,
    usarSidebarLayout: boolean,
    ultimaTentativaDeLogin?: Date,
}

const INITIAL_STATE: State = {
    token: "",
    tenantId: "",
    logado: false,
    expirado: false,
    administrador: false,
    tentativasDeLogin: 0,
    usarSidebarLayout: false,
    ultimaTentativaDeLogin: undefined,
};

const reducer: Reducer<State> = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case "LOG_IN":
            return { ...state, token: action.token, logado: true, expirado: false, usarSidebarLayout: action.usarSidebarLayout, tentativasDeLogin: 0, ultimaTentativaDeLogin: undefined, }
        case "LOG_OUT":
            return { ...state, token: "", logado: false, expirado: false, usarSidebarLayout: false, }
        case "LOG_OUT_EXPIRED":
            return { ...state, token: "", logado: false, expirado: true, usarSidebarLayout: false, }
        case "LOG_IN_FAILED":
            return { ...state, tentativasDeLogin: state.tentativasDeLogin + 1, ultimaTentativaDeLogin: new Date(), };
        case "RESET_LOGIN_ATTEMPTS":
            return { ...state, tentativasDeLogin: 0, ultimaTentativaDeLogin: undefined, };
        default:
            return state;
    }
}

export default reducer;